<template>
    <ToastClose
        v-bind="delegatedProps"
        :class="
            cn(
                'absolute right-2 top-2 rounded-md p-1 text-gray-950/50 hover:text-gray-950 focus:outline-hidden focus:ring-2',
                props.class
            )
        ">
        <i class="text-xl fass fa-xmark"></i>
    </ToastClose>
</template>
<script setup lang="ts">
import { type HTMLAttributes, computed } from "vue";
import { ToastClose, type ToastCloseProps } from "reka-ui";

const props = defineProps<
    ToastCloseProps & {
        class?: HTMLAttributes["class"];
    }
>();

const delegatedProps = computed(() => {
    const { class: _, ...delegated } = props;

    return delegated;
});
</script>
